import React, { useEffect, useState } from 'react';
import { getSessionData } from '../../services/sessionDataService';
import {
  initializeFromConfigState,
  InitializeFromConfigStateForManifold
} from '../../services/configuratorService';

import { getContactInfo } from '../../services/contactService';

import {
  getTranslations,
  assignTranslations
} from '../../services/translationService';

import {
  getUniquePartIdentifierforManifold,
  uniqueCodeTemplate
} from '../../services/bomService';

import SummaryComponents from './summaryComponent';

import loader from '../assets/images/loader.gif';
import '../assets/css/overlay.css';
import { getQueryParam } from '../../services/commonService';
import { getManufacturingLocation } from '../../services/locationService';

function Summary(props) {
  const [startData, setStartData] = useState();
  const [contactInfo, setContactInfo] = useState();
  const [sessionData, setSessionData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [displayPartNumber, setDisplayPartNumber] = useState();
  const [uniquePartIdentifier, setUniquePartIdentifier] = useState();

  let translations = assignTranslations(null);

  const [rightLan, setRightLan] = useState(translations?.rightLan);

  useEffect(() => {
    async function fetchData() {
      const queryParams = getQueryParam();
      let session = queryParams.get('session');

      var sessionData = await getSessionData(session);

      if (!sessionData) return;

      setSessionData(sessionData);
      if (sessionData.configModel == 'V20') isNormalProduct = false;

      let response;

      if (sessionData.stepNames.length > 1) {
        //manifold product
        response = await InitializeFromConfigStateForManifold(
          sessionData.configModel,
          sessionData.configState,
          sessionData.stepNames
        );
      } else {
        response = await initializeFromConfigState(
          sessionData.configModel,
          sessionData.stepNames[0],
          sessionData.configState,
          ''
        );
      }

      let mLocation = await getManufacturingLocation(
        sessionData.manufacturingDivision,
        sessionData.configModel
      );

      sessionData.manufacturingLocation = mLocation;

      setDisplayPartNumber(await getDisplayPartNumber(response, sessionData));

      setStartData(response);

      let contactInfo = await getContactInfo(sessionData);
      let translations = await getTranslations(sessionData?.language);
      if (translations) {
        setRightLan(translations?.rightLan ? translations?.rightLan : rightLan);
      }

      setContactInfo(contactInfo);
      setIsLoading(false);
    }

    fetchData();
  }, []);

  const getUniquePartIdentifier = async (startData, sessionData) => {
    let uniquePartNumner;
    var uniqueCode = uniqueCodeTemplate(startData);
    if (uniqueCode) {
      uniquePartNumner = await getUniquePartIdentifierforManifold(
        startData,
        sessionData
      );
    }
    return uniquePartNumner;
  };

  const getDisplayPartNumber = async (startData, sessionData) => {
    let uniquePartIdentifier = await getUniquePartIdentifier(
      startData,
      sessionData
    );
    setUniquePartIdentifier(uniquePartIdentifier);
    if (startData.isManifoldProduct) {
      setDisplayPartNumber(uniquePartIdentifier);
    }
  };

  return (
    <>
      {!isLoading ? (
        <SummaryComponents
          isModal={false}
          contactus={contactInfo}
          dataItems={startData}
          sessionDataItems={sessionData}
          lang={rightLan}
          displayPartNumber={displayPartNumber}
          orderSummarySteps={startData?.tactonModel?.steps}
          uniquePartIdentifier={uniquePartIdentifier}
        />
      ) : (
        <div>
          <div className="loading-overlay">
            <div className="loader-text">
              <img src={loader} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Summary;
